"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeEventMap = exports.RemoveItemCacheEvent = exports.GetItemCacheEvent = exports.SetItemCacheEvent = exports.ClearCacheEvent = void 0;
const eventBusBasic_1 = require("../../eventBus/eventBusBasic");
var BaseTypeMap;
(function (BaseTypeMap) {
    BaseTypeMap["REMOVE"] = "REMOVE";
    BaseTypeMap["CLEAR"] = "CLEAR";
    BaseTypeMap["SET"] = "SET";
    BaseTypeMap["GET"] = "GET";
})(BaseTypeMap || (BaseTypeMap = {}));
class ClearCacheEvent extends eventBusBasic_1.Event {
}
exports.ClearCacheEvent = ClearCacheEvent;
class SetItemCacheEvent extends eventBusBasic_1.Event {
}
exports.SetItemCacheEvent = SetItemCacheEvent;
class GetItemCacheEvent extends eventBusBasic_1.Event {
}
exports.GetItemCacheEvent = GetItemCacheEvent;
class RemoveItemCacheEvent extends eventBusBasic_1.Event {
}
exports.RemoveItemCacheEvent = RemoveItemCacheEvent;
exports.TypeEventMap = {
    [BaseTypeMap.CLEAR]: ClearCacheEvent,
    [BaseTypeMap.GET]: GetItemCacheEvent,
    [BaseTypeMap.REMOVE]: RemoveItemCacheEvent,
    [BaseTypeMap.SET]: SetItemCacheEvent,
};
//# sourceMappingURL=types.js.map